import React from 'react';
import { Trans } from 'react-i18next';
import { Box, Typography, Link as MUILink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Reusable legal note with links to Terms and (placeholder) Privacy Policy.
 *
 * Props:
 *  - i18nKey: i18n key to render (default: 'signInNoteRich')
 *  - termsPath: router path to Terms page (default: '/terms-of-use')
 *  - privacyPath: router path to Privacy page (default: '/privacy-policy')
 *  - sx, color, align, mt: style controls passed to Typography
 */
const Note = ({
  i18nKey = 'signInNoteRich',
  termsPath = '/terms-of-use',
  privacyPath = '/privacy-policy',
  sx = {},
  color = 'text.secondary',
  align = 'center',
  mt = 2,
}) => (
  <Typography variant="body2" sx={{ color, mt, textAlign: align, ...sx }}>
    <Trans
      i18nKey={i18nKey}
      components={{
        tos: <MUILink component={RouterLink} to={termsPath} underline="always" color="inherit" />,
        pp:  <MUILink component={RouterLink} to={privacyPath} underline="always" color="inherit" />
      }}
    />
  </Typography>
);

export default Note;
export { Note };